/**
 * Estado único em memória para mocks admin + vitrine (mesma aba; não persiste em F5).
 * Seed alinhado ao backend: `DevelopmentDataSeeder` + `mock-api-development-seed.ts`.
 */
import {
  MOCK_SEED_CITIES,
  MOCK_SEED_DISTRICTS_BY_CITY,
  buildDevelopmentSeedPropertyRecords,
} from '@app/mock-api/mock-api-development-seed';
import type { MockCity, MockDistrict, MockPropertyRecord } from '@app/mock-api/mock-api-shared-models';

/** Garante uma única inicialização por carregamento do bundle (HMR pode reexecutar). */
let seeded = false;

export const mockApiCities: MockCity[] = [];

export const mockApiDistrictsByCity: Record<string, MockDistrict[]> = {};

export const mockApiProperties = new Map<string, MockPropertyRecord>();

export function ensureMockApiPropertyStoreSeeded(): void {
  if (seeded)
    return;

  seeded = true;
  mockApiCities.length = 0;
  mockApiCities.push(...MOCK_SEED_CITIES.map((c) => ({ ...c })));

  for (const k of Object.keys(mockApiDistrictsByCity))
    delete mockApiDistrictsByCity[k];

  for (const c of mockApiCities) {
    const rows = MOCK_SEED_DISTRICTS_BY_CITY[c.id] ?? [];
    mockApiDistrictsByCity[c.id] = rows.map((d) => ({ ...d }));
  }

  mockApiProperties.clear();

  for (const p of buildDevelopmentSeedPropertyRecords()) {
    mockApiProperties.set(p.id, {
      ...p,
      images: p.images.map((i) => ({ ...i })),
    });
  }
}
